// extracted by mini-css-extract-plugin
module.exports = {"base":"searchesPage_base__bwi50","loadingContainer":"searchesPage_loadingContainer__35WiS","noResultsText":"searchesPage_noResultsText__1U6kF","error":"searchesPage_error__3JXF5"};